import { AxiosInstance } from '../axiosInstance'

export async function sendOtp(payLoad) {
  const response = await AxiosInstance.post('/sendOTP', payLoad);
  return response.data;
}
